import React, { useEffect, useState } from "react";
// Stick to your working legacy import 
import { useTransition, animated, config } from 'react-spring';

import img1 from "../pictures/live_trading.PNG";
import img2 from "../pictures/MT5_adviser.PNG";
import img3 from "../pictures/trading_intelligence.PNG";
import img4 from "../pictures/licence_installation.PNG";
import img5 from "../pictures/MainTable_2.PNG";

const slides = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 }
    //{ id: 5, image: img5 }
];

export default function LoginSlideshow() {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex(i => (i + 1) % slides.length);
        }, 9000);

        return () => clearInterval(timer);
    }, []);

    // Legacy v8 syntax configures keys outside the primary object 
    // and expects the specific single item to be passed first.
    const transitions = useTransition(slides[index], item => item.id, {
        from: {
            opacity: 0,
            transform: "translateX(100%)",
            position: "absolute" // Keeps entering/leaving images stacked on top of each other
        },
        enter: {
            opacity: 1,
            transform: "translateX(0%)"
        },
        leave: {
            opacity: 0,
            transform: "translateX(-40%)"
        },
        config: config.molasses
    });

    return (
        <div className="login-slideshow  bg-light" style={{ position: "relative", overflow: "hidden" }}>
            {/* Legacy v8 syntax returns an array that requires `.map()` */}
            
            {transitions.map(({ item, props, key }) => (
                <animated.img
                    key={key}
                    style={props} // Older versions use 'props' instead of 'style'
                    src={item.image}
                    height = {"400px"}
                    className="login-slide"
                    alt="iDMS"
                />
            ))}
            
        </div>
    );
}
